import { render } from "./video-grid.vue?vue&type=template&id=2d7d329f"
import script from "./video-grid.vue?vue&type=script&lang=js"
export * from "./video-grid.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Cfcu.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__